<template>
  <div class="payout-summary-cards">
    <!-- Card principale viola con saldo disponibile -->
    <CCard class="payout-main-card border-0 shadow mb-4">
      <CCardBody class="text-white">
        <h2 class="display-4 font-weight-bold mb-1">
          {{ statistics.total_amount_pending | currency(currency) }}
        </h2>
        <div class="mb-4 opacity-90">
          <translate translate-context="payout.main">Amount pending for payout</translate>
        </div>
        <CButton
          v-if="showPayoutButton && canRequestPayout"
          color="light"
          size="lg"
          class="text-primary font-weight-bold px-5"
          @click="requestPayout"
        >
          <CIcon name="cipWallet" class="mr-2" />
          <translate translate-context="payout.main">Richiedi Payout</translate>
        </CButton>
      </CCardBody>
    </CCard>

    <!-- Cards statistiche sotto -->
    <CRow class="stats-cards">
      <CCol sm="6" lg="3">
        <CCard class="border-0 shadow-sm text-center h-100">
          <CCardBody>
            <div class="display-5 font-weight-bold mb-2">
              {{ statistics.total_photos_sold || 0 }}
            </div>
            <div class="text-muted small text-uppercase">
              <translate translate-context="payout.stats">Photos Sold</translate>
            </div>
          </CCardBody>
        </CCard>
      </CCol>

      <CCol sm="6" lg="3">
        <CCard class="border-0 shadow-sm text-center h-100">
          <CCardBody>
            <div class="display-5 font-weight-bold text-primary mb-2">
              {{ statistics.total_orders || 0 }}
            </div>
            <div class="text-muted small text-uppercase">
              <translate translate-context="payout.stats">Total Orders</translate>
            </div>
          </CCardBody>
        </CCard>
      </CCol>

      <CCol sm="6" lg="3">
        <CCard class="border-0 shadow-sm text-center h-100">
          <CCardBody>
            <div class="display-5 font-weight-bold text-warning mb-2">
              {{ statistics.total_amount_requested | currency(currency) }}
            </div>
            <div class="text-muted small text-uppercase">
              <translate translate-context="payout.stats">Requested</translate>
            </div>
          </CCardBody>
        </CCard>
      </CCol>

      <CCol sm="6" lg="3">
        <CCard class="border-0 shadow-sm text-center h-100">
          <CCardBody>
            <div class="display-5 font-weight-bold text-success mb-2">
              {{ statistics.total_amount_paid | currency(currency) }}
            </div>
            <div class="text-muted small text-uppercase">
              <translate translate-context="payout.stats">Already Paid</translate>
            </div>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import { CButton, CIcon } from '@coreui/vue'

export default {
  name: 'PayoutSummaryCards',
  components: {
    CButton,
    CIcon
  },
  props: {
    statistics: {
      type: Object,
      required: true
    },
    currency: {
      type: String,
      default: 'EUR'
    },
    showPayoutButton: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    canRequestPayout() {
      // Check if there's any pending amount available for payout
      return parseFloat(this.statistics.total_amount_pending || 0) > 0 ||
             this.statistics.pending_payouts > 0
    }
  },
  methods: {
    requestPayout() {
      this.$emit('request-payout')
    }
  }
}
</script>

<style scoped>
/* Card principale viola con gradiente */
.payout-main-card {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  overflow: hidden;
  position: relative;
}

.payout-main-card::before {
  content: '';
  position: absolute;
  top: -50%;
  right: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%);
  animation: shimmer 3s ease-in-out infinite;
  pointer-events: none;
  z-index: 0;
}

@keyframes shimmer {
  0%, 100% { transform: translate(0, 0); }
  50% { transform: translate(-10%, -10%); }
}

.payout-main-card .card-body {
  position: relative;
  z-index: 1;
}

.payout-main-card .display-4 {
  font-size: 3rem;
  letter-spacing: -0.02em;
}

.opacity-90 {
  opacity: 0.9;
}

.stats-cards .display-5 {
  font-size: 1.75rem;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .payout-main-card .display-4 {
    font-size: 2rem;
  }
  
  .stats-cards .display-5 {
    font-size: 1.5rem;
  }
}
</style>